module.exports = __webpack_public_path__ + "img/avatar4.b103417d.png";